var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 10.375V8.125C21.375 7.50512 20.871 7 20.25 7H11.25C10.6301 7 10.125 7.50512 10.125 8.125V23.875C10.125 24.496 10.6301 25 11.25 25H20.25C20.871 25 21.375 24.496 21.375 23.875V20.5H20.25V21.625H11.25V9.25H20.25V10.375H21.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11.5H16.5C15.8801 11.5 15.375 12.0051 15.375 12.625V17.125C15.375 17.7561 15.8689 18.25 16.5 18.25H17.625V19.375C17.625 19.5876 17.7454 19.7822 17.9355 19.8779C18.0154 19.9172 18.102 19.9375 18.1875 19.9375C18.3068 19.9375 18.426 19.8993 18.525 19.825L20.6254 18.25H23.25C23.8811 18.25 24.375 17.7561 24.375 17.125V12.625C24.375 11.9939 23.8811 11.5 23.25 11.5ZM18.21 15.4375C17.8995 15.4375 17.6419 15.1855 17.6419 14.875C17.6419 14.5645 17.8871 14.3125 18.1988 14.3125H18.21C18.5205 14.3125 18.7725 14.5645 18.7725 14.875C18.7725 15.1855 18.5205 15.4375 18.21 15.4375ZM21.585 15.4375C21.2756 15.4375 21.0169 15.1855 21.0169 14.875C21.0169 14.5645 21.2633 14.3125 21.5738 14.3125H21.585C21.8955 14.3125 22.1475 14.5645 22.1475 14.875C22.1475 15.1855 21.8955 15.4375 21.585 15.4375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsMessage);
export default __webpack_public_path__ + "static/media/sms-message.e0fdba330d3f078a85672bda8008fa79.svg";
export { ForwardRef as ReactComponent };